import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";
import { Ornament } from "@/components/SectionTitle";
import { StatusBadge } from "@/components/StatusBadge";
import { PROJECTS, projectPath } from "@/data/site";

const spring = PROJECTS.find((p) => p.slug === "rainforest-spring-water");

export const SpringShowcase = () => (
  <section className="relative overflow-hidden py-20 lg:py-28" data-testid="home-spring-showcase">
    <div className="mx-auto grid max-w-[1440px] items-center gap-12 px-5 md:px-10 lg:grid-cols-12">
      <FadeUp className="lg:col-span-7 lg:order-2">
        <div className="border border-gold/50 p-2 md:p-3 shadow-[0_30px_80px_-40px_rgba(14,38,31,0.6)]">
          <img src={spring.plan.src} alt={spring.plan.alt} loading="lazy" className="block h-auto w-full" />
        </div>
      </FadeUp>
      <FadeUp delay={0.1} className="lg:col-span-5 lg:order-1">
        <Ornament />
        <p className="mt-3 font-caps text-[12px] tracking-[0.32em] uppercase text-gold-deep">From the Estate</p>
        <h2 className="mt-4 font-caps text-3xl leading-tight text-heritage md:text-[2.7rem]">Rainforest Spring Water</h2>
        <p className="mt-6 text-lg leading-relaxed text-muted-ink">
          Tobago's rainforest, protected since 1776, gathers the rain that feeds the island's springs, rivers and waterfalls. Fresh water once drew sailors to these shores. Today it is one of the estate's quiet treasures.
        </p>
        <p className="mt-4 text-lg leading-relaxed text-muted-ink">
          Rainforest Spring Water is the estate's initiative to conserve its natural freshwater resources and explore their potential future development.
        </p>
        <div className="mt-6"><StatusBadge status={spring.status} testid="spring-showcase-status" /></div>
        <Link to={projectPath(spring)} data-testid="spring-showcase-button" className="group mt-9 inline-flex items-center gap-3 border border-gold-deep bg-gold-deep px-7 py-4 font-caps text-[12px] tracking-[0.24em] uppercase text-ivory transition-colors duration-500 hover:border-heritage hover:bg-heritage">
          Discover the Project <ArrowRight size={15} className="transition-transform duration-500 group-hover:translate-x-1" />
        </Link>
      </FadeUp>
    </div>
  </section>
);
